const VIET_NUMBERS = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];

function readThreeDigits(number) {
    let hundred = Math.floor(number / 100);
    let ten = Math.floor((number % 100) / 10);
    let unit = number % 10;

    let result = "";

    if (hundred > 0) {
        result += VIET_NUMBERS[hundred] + " trăm";
        if (ten === 0 && unit > 0) result += " lẻ";
    }

    if (ten > 1) {
        result += " " + VIET_NUMBERS[ten] + " mươi";
        if (unit === 1) result += " mốt";
        else if (unit === 5) result += " lăm";
        else if (unit > 0) result += " " + VIET_NUMBERS[unit];
    } else if (ten === 1) {
        result += " mười";
        if (unit === 1) result += " một";
        else if (unit === 5) result += " lăm";
        else if (unit > 0) result += " " + VIET_NUMBERS[unit];
    } else if (ten === 0 && unit > 0 && hundred === 0) {
        result += VIET_NUMBERS[unit];
    }

    return result.trim();
}

export function NumberToVietnamese(num) {
    if (num === 0) return "không";

    const units = ["", " nghìn", " triệu", " tỷ"];
    let result = "";
    let unitIndex = 0;

    while (num > 0) {
        let chunk = num % 1000;
        if (chunk > 0) {
            result = readThreeDigits(chunk) + units[unitIndex] + (result ? " " + result : "");
        }
        num = Math.floor(num / 1000);
        unitIndex++;
    }

    return result.trim();
}
